module.exports = __webpack_public_path__ + "img/child.1a443eb5.png";